export class ImportFileMetaData {
    public fileName: string;

    // public mimeType: string; // can be derived from file name by MimeUtils on server side
}
